import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'gg-contact-icon',
  templateUrl: './contact-icon.component.html',
  styleUrls: ['./contact-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContactIconComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
